module.exports = __webpack_public_path__ + "img/ico-email.99e26a51.svg";